import { render, staticRenderFns } from "./DashboardProductsDutyPaidShipments.vue?vue&type=template&id=21b0aaf2&"
import script from "./DashboardProductsDutyPaidShipments.vue?vue&type=script&lang=js&"
export * from "./DashboardProductsDutyPaidShipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
